import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar, Footer, BlobCursor } from "./components/Layout";
import Home from "./pages/Home";
import Studio from "./pages/Studio";
import Warsztaty from "./pages/Warsztaty";
import Kontakt from "./pages/Kontakt";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App grain min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <BlobCursor />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/warsztaty" element={<Warsztaty />} />
            <Route path="/kontakt" element={<Kontakt />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
